import { Station } from '../../../integrated-client/models/Station'

export interface IStationEditorData {
  stationData?: Station
  validation?: any
}
export class StationEditorData implements IStationEditorData {

  stationData?: Station
  validation?: any
}